import React, { useState, useEffect, useRef } from "react";
import CancelIcon from "@mui/icons-material/Cancel";

const CustomSearchSelect = ({
    options = [],
    value,
    onChange,
    placeholder = "Select",
    width = "100%",
    disabled = false,
    locationLoader,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);

    // Filter options based on search term
    const filteredOptions = options.filter(option =>
        option?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())
    );

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Get the selected option label
    const selectedOption = options.find(opt => opt.id === value);

    return (
        <div
            className="position-relative"
            ref={dropdownRef}
            style={{ width }}
        >
            <div
                className={`input-pop-new ps-2 d-flex align-items-center justify-content-between ${disabled ? "bg-light" : ""}`}
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    opacity: disabled ? 0.7 : 1,
                    width: "100%"
                }}
                onClick={() => !disabled && setIsOpen(!isOpen)}
            >
                <span className="text-truncate">
                    {selectedOption ? selectedOption.name : placeholder}
                </span>
                {value ? (
                    <CancelIcon
                        fontSize="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onChange("");
                        }}
                        style={{ cursor: "pointer" }}
                    />
                ) : (
                    <span className="ms-2">▼</span>
                )}
            </div>

            {isOpen && !disabled && (
                <div
                    className="position-absolute bg-white shadow-sm p-2 mt-1 w-100"
                    style={{
                        zIndex: 1000,
                        maxHeight: "200px",
                        overflow: "hidden",
                        border: "1px solid #ddd",
                        borderRadius: "4px"
                    }}
                >
                    <input
                        type="text"
                        placeholder="Search..."
                        style={{
                            borderRadius: '10px',
                            border: '1px solid #8d4800',
                        }}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                        autoFocus
                    />

                    <div style={{ maxHeight: "150px", overflowY: "auto" }}>
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => (
                                <div
                                    key={option.id}
                                    className={`p-2 ${value === option.id ? "bg-light" : ""}`}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom: "1px solid #f0f0f0"
                                    }}
                                    onClick={() => {
                                        onChange(option.id);
                                        setIsOpen(false);
                                        setSearchTerm("");
                                    }}
                                >
                                    {option.name}
                                </div>
                            ))
                        ) : locationLoader ? <div>
                            <div className="p-2 text-muted">Loading...</div>
                        </div> : (
                            <div className="p-2 text-muted">No options found</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomSearchSelect;